export default __webpack_public_path__ + "a281a2588f26d88116eda17ebdc82f3f.png";